import { get, keys, flow, pickBy, isEqual } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getPageLayout = get('inventory.components.pageLayout');

export const getSidebarNavExpanded = createSelector(
  getPageLayout,
  get('sidebarNavExpanded')
);

export const getDropdownNavItemsExpanded = createSelector(
  getPageLayout,
  get('dropdownNavItemsExpanded')
);

export const getDropdownNavOpenKeys = createSelector(
  getDropdownNavItemsExpanded,
  flow(
    pickBy(isEqual(true)),
    keys
  )
);

export const getInventoryItemsTemplateDownloadUrl = createSelector(
  getPageLayout,
  get('itemsTemplateDownloadUrl')
);

export const getIsFetchingInventoryItemsTemplateDownloadUrl = createSelector(
  getPageLayout,
  get('fetchingItemsTemplateDownloadUrl')
);
